import { z } from 'zod';
import { EmptyObject } from 'libs/end-to-end/src/generic';
import { createCustomVizRequestSchema } from 'libs/end-to-end/src/custom-viz/createCustomVizRequestSchema';

export const StreamlitCustomVizExtras = z
  .object({
    streamlitAppId: z.string(),
  })
  .describe('StreamlitCustomVizExtras');

export type StreamlitCustomVizExtras = z.infer<typeof StreamlitCustomVizExtras>;

export const StreamlitCustomVizInputs = z.object({
  dropdowns: EmptyObject,
  extras: StreamlitCustomVizExtras,
});

export const StreamlitCustomVizRequest = createCustomVizRequestSchema(
  'externalStreamlit',
  StreamlitCustomVizInputs,
);

export type StreamlitCustomVizRequest = z.infer<
  typeof StreamlitCustomVizRequest
>;

export const StreamlitCustomVizOutput = z
  .object({
    streamlitAppId: z.string(),
  })
  .describe('StreamlitCustomVizOutput');

export type StreamlitCustomVizOutput = z.infer<typeof StreamlitCustomVizOutput>;
